'use client'

import { Activity } from '@/containers/Activity'

export default function ActivityPage() {
  return <Activity />
}
